"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePaymentMethods = void 0;

var _reactQuery = require("react-query");

var _api = require("../api");

var _account = require("../../account");

var _types = require("../types");

var usePaymentMethods = function usePaymentMethods() {
  var isAuthenticated = (0, _account.useAuthenticated)();
  var logout = (0, _account.useLogout)()[0];
  return (0, _reactQuery.useQuery)(_types.QueryKeys.PaymentMethods, function () {
    return (0, _api.fetchPaymentMethods)();
  }, {
    enabled: isAuthenticated,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 20 * 60000,
    onError: function onError(error) {
      var _a;

      if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        logout();
      }
    }
  });
};

exports.usePaymentMethods = usePaymentMethods;